import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import "@fontsource-variable/newsreader";
import "./styles.css";
import App from "./App";
import { desktop } from "./lib/desktop";
import { loadDesktopLiveConfig } from "./config/env";
import { reloadOnNewVersion } from "./lib/newVersion";

// A page still open from before an update asks for files the update replaced: load the new version once, instead of
// "Importing a module script failed" (seen on phones, where Studio stays open for days).
reloadOnNewVersion(window, sessionStorage);

// Files dropped outside the conversation should do nothing (never open the file in the window).
for (const ev of ["dragover", "drop"] as const) window.addEventListener(ev, (e) => e.preventDefault());

// VERA.exe tells the UI whether live VERA is switched on (vera.config.json), then the app starts.
void loadDesktopLiveConfig(desktop).finally(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
